import React, { Component } from 'react';
import styled from 'styled-components';
import arrow from '../configurator/arrow.svg'
import Select from 'react-select'
import {withRouter} from "react-router-dom";

const CarTypeFieldUl = styled.ul`
    height: 40px;
    line-height:40px;
    border: 1px #ddd solid;
    line-height: 30px;
    border-radius: 2px;
    font-size: 12px;
    margin: 2px 0px;
    
    li:not(:last-child) {
        border-right: 1px #ddd solid;
    }
    display: inline-block;
    
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    max-width: calc(100% - 16px);

    @media (max-width: 420px) {
      // max-width: calc(100% - 55px);
      margin-top: 10px;
      display: none;
    }
    .fontShadow {
      text-shadow: 0px 0px 0px #333;
    }
    .option__item {
        display: inline-block;
        height: 40px;
        font-size: 1rem;
        line-height: 40px;
        padding-left: 12px;
        padding-right: 12px;
        text-align: center;
        cursor: pointer;

        color: #FFF;
        background-color: #9C0000;
        
        &--inactive {
            /*background-color: #a4a4a4;*/
            color: #000;
            background-color: #FFF;
        }
    }
    
`

const CarTypeDropdownWrap = styled.div`
  .field-dropdown {
    margin: 0 auto;
  }

  display: none;

  @media (max-width: 420px) {
    display: block;
  }
`;

class CarTypeField extends Component {

  state = {
    selectedValue: {}
  }

  componentDidUpdate = (prevProps) => {

    const prevVal = Object.keys(prevProps.value)[0]
    
    let currVal = Object.keys(this.props.value)[0]

    console.log(prevVal, currVal, this.state.selectedValue)


    let selectedValue = {
      label: currVal,
      value: currVal
    }

    if (currVal === "value") {
      selectedValue = {
        label: 'All',
        value: 'All'
      }
    }
    
    if (prevVal !== currVal && currVal !== Object.keys(this.state.selectedValue)[0]) {
      this.setState({
        selectedValue
      })
    }
  }

  componentDidMount = () => {
    let id = this.props.match.params.id;

    if (id) {
      this.setState({
        selectedValue: {
          label: id.toUpperCase(),
          value: id.toUpperCase()
        }
      })
    }
    else {
      this.setState({
        selectedValue: {
          label: "All",
          value: "All"
        }
      })
    }
  }

  onChangeDropDown = (val) => {

    this.setState({ selectedValue: {label: val.label, value: val.label} }, () => {

      console.log(val)

      const dropValue = val.label;
      if (dropValue === "All") {
        this.props.onChange({
          [dropValue]: true,
        })
      }
      else {
        this.props.onChange({
          [dropValue]: true,
        });
      }
    });
  }

  render() {
    let options = this.props.options || [];

    if (!options.length) {
      return [];
    }

    if (options[0].label !== "All") {
      options.unshift({
        value: true,
        label: "All"
      })
    }

    let dropdownOptions = [];

    options.map((i) => {
      dropdownOptions.push({
        value: i.label,
        label: i.label
      })
    })

    const customStyles = {
      control: () => ({
        borderRadius: '0',
        border: '1px solid #BFC0C1',
        maxWidth: '170px',
        margin: '0 auto'
      }),
      menu: () => ({
        width: '100%',
        maxWidth: '170px',
        margin: '0 auto',
        borderRadius: '0',
        border: '1px solid #BFC0C1',
        position: 'absolute',
        left: '0',
        right: '0',
        zIndex: '2'
      }),
      dropDownIndicator: () => ({
        backgroundUrl: arrow
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#101010' : '#FFF',
        fontSize: '14px',
        fontWeight: 'bold',
        color: state.isSelected ? '#FFF' : '#890000' 
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
      valueContainer: () => ({
        display: 'inline-block',
        width: '130px',
        verticalAlign: '5px',
        padding: '9px 0',
        paddingLeft: '30px',
      }),
      indicatorsContainer: () => ({
        display: 'inline-block',
        width: '30px',
        // padding: '9px 0',
        height: '100%'
      }),
      singleValue: () => ({
        display: 'inline-block',
        color: '#890000',
        fontSize: '14px',
        fontWeight: 'bold'
      }),
      dropdownIndicator: defaultStyles => ({
        ...defaultStyles,
        '& svg': { display: 'none' },
        background: `url(${arrow}) no-repeat right #AAA`,
        backgroundSize: '24px 10px',
        backgroundColor: 'transparent',
        display: 'inline-block',
        width: '100%',
        height: '20px'
      }),
      menuList: () => ({
        paddingTop: '0',
        paddingBottom: '0'
      })

      // control: () => ({
      //   // none of react-select's styles are passed to <Control />
      //   width: 200,
      // }),
      // singleValue: (provided, state) => {
      //   const opacity = state.isDisabled ? 0.5 : 1;
      //   const transition = 'opacity 300ms';

      //   return { ...provided, opacity, transition };
      // }

    }

    return <div>
      <CarTypeFieldUl>
        {
          options.map((i, key) => {
            if (i.label === "All") {
              return <li
                key
                onClick={e => {
                  return this.props.onChange({
                    value: true,
                  })
                }}
                className={`option__item ${!this.props.value.value ? 'option__item--inactive' : 'fontShadow'}`}
              >
                All
              </li>
            }

            return <li
              key={key}
              onClick={e => {
                let selected = this.props.value[i.value];
                let totalSelected = this.props.options.map(i => this.props.value[i.value] ? 1 : 0).reduce((acc, item) => acc + item, 0);

                if (totalSelected == 1 && selected) {
                  //nothing, we don't allow user to un-select the last option              
                } else {
                  return this.props.onChange({
                    //...this.props.value,
                    [i.value]: !selected,
                  });
                }
              }}

              className={`option__item ${!this.props.value[i.value] ? 'option__item--inactive' : 'fontShadow'}`}>
              {i.label}
            </li>
          })
        }</CarTypeFieldUl>

      <CarTypeDropdownWrap>
        <Select
          className="field-dropdown"
          styles={customStyles}
          options={dropdownOptions}
          onChange={this.onChangeDropDown}
          value={this.state.selectedValue}
          defaultValue={this.state.selectedValue}
          isSearchable={false}
          placeholder=""
        />
      </CarTypeDropdownWrap>
      {/* <CarTypeFieldDropdown ref={i => this.dropdown = i} className="dropdown" onChange={this.onChangeDropDown} value={''}>
          {
            options.map((i, idx) => {
              if (i.label === "All") {
                return <option key={idx} value={"value"}>{i.label}</option>
              }
              return <option key={idx} value={i.label}>{i.label}</option>
            })
          }
        </CarTypeFieldDropdown> */}
    </div>
  }

}

export default withRouter(CarTypeField);


// WEBPACK FOOTER //
// ./src/components/car-model-page/CarTypeField.js